<template>
  <el-table
    :data="pickup.consignments"
    size="mini"
    stripe
  >
    <el-table-column
      type="expand"
      class="p-0 m-0"
    >
      <template slot-scope="props">
        <el-table
          :data="props.row.items"
          size="mini"
          :border="true"
          stripe
        >
          <el-table-column
            label="Description"
            prop="item_desc"
            width="88"
            :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
          />
          <el-table-column
            label="Reference"
            prop="item_ref"
            :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
          />
          <el-table-column
            label="Type"
            prop="type"
            width="60"
            :formatter="(row, col, cellValue) => cellValue ? (cellValue.type_desc || '-') : '-'"
          />
          <el-table-column
            label="Length"
            prop="item_length"
            width="60"
            :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
          />
          <el-table-column
            label="Width"
            prop="item_width"
            width="60"
            :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
          />
          <el-table-column
            label="Height"
            prop="item_height"
            width="60"
            :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
          />
          <el-table-column
            label="Weight"
            prop="item_weight"
            width="63"
            :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
          />
          <el-table-column
            label="Qty."
            prop="item_qty"
            width="60"
            :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
          />
        </el-table>
      </template>
    </el-table-column>

    <el-table-column
      label="Consignment"
    >
      <template v-slot="{ row }">
        <slot
          name="con_full"
          :consignment="row"
        >
          <ConsignmentLink :consignment="row">
            {{ row.con_full }}
          </ConsignmentLink>
        </slot>
      </template>
    </el-table-column>

    <el-table-column
      label="Dangerous Goods"
      prop="con_is_dg"
      :formatter="(row, col, cellValue) => cellValue ? 'Yes' : 'No'"
    />
  </el-table>
</template>

<script>
import ConsignmentLink from '@/components/Popovers/ConsignmentLink'

export default {
  components: {
    ConsignmentLink
  },
  props: {
    pickup: {
      type: Object,
      required: true
    }
  }
}
</script>
